import classNames from 'classnames';
import { useCallback } from 'react';
import { Button } from 'yoso';
import { useLogin } from '~/components/Auth';
import { myCitizenItemsUrl } from '~/components/Dosi/Dosi.hooks';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { ErrorFallback, ErrorFallbackProps } from '~/components/Error';
import { ErrorMessage } from '~/components/Error/Message';
import { T } from '~/components/I18n';
import hatCitizen from '~/components/Icon/Citizen/hatCitizen.png';
import cat from '~/components/Icon/cat.png';
import wallet from '~/components/Icon/wallet.png';
import { useMember } from '~/components/Member/Member.hooks';
import styles from './MarketplaceNftFallback.module.scss';
export type MarketplaceNftFallbackProps = ErrorFallbackProps & {
  className?: string;
};

const CITIZEN_STORE_URL = import.meta.env.VITE_CITIZEN_STORE_URL;

export const MarketplaceNftFallback = (props: MarketplaceNftFallbackProps) => {
  const { error, className } = props;
  const {
    data: { isLoggedIn },
  } = useMember();
  const login = useLogin();
  const { open } = useEmbeddedViewer();

  const onButtonClick = useCallback(() => {
    if (!isLoggedIn) {
      login();
    } else {
      open(myCitizenItemsUrl);
    }
  }, [open, isLoggedIn, login]);

  switch (error.message) {
    case 'NFT_EMPTY':
      return (
        <ErrorMessage
          className={classNames(styles.root, className)}
          title={<T className={styles.title} name="citizen_home_c2c_all_empty_title" />}
          description={<T name="citizen_home_c2c_all_empty_desc" />}
          icon={<img className={styles.image} src={wallet} alt="no item" width={82} height={82} />}>
          <Button className={styles.button} color="primary" onClick={onButtonClick}>
            <T name="citizen_button_title_go_mynft" />
          </Button>
        </ErrorMessage>
      );
    case 'CITIZEN_EMPTY':
      return (
        <ErrorMessage
          className={classNames(styles.root, className)}
          title={<T className={styles.title} name="citizen_home_c2c_citizen_empty_title" />}
          description={<T name="citizen_home_c2c_citizen_empty_desc" />}
          icon={
            <img
              className={styles.image}
              src={hatCitizen}
              alt="no citizen"
              width={82}
              height={82}
            />
          }>
          <Button className={styles.button} color="primary" onClick={onButtonClick}>
            <T name="citizen_button_title_go_mynft" />
          </Button>
        </ErrorMessage>
      );
    case 'PET_EMPTY':
      return (
        <ErrorMessage
          className={classNames(styles.root, className)}
          title={<T name="citizen_home_c2c_pet_empty_title" />}
          description={<T name="citizen_home_c2c_pet_empty_desc" />}
          icon={<img className={styles.image} src={cat} alt="no friend" width={82} height={82} />}>
          <Button
            className={styles.button}
            as="a"
            href={`${CITIZEN_STORE_URL}/1st_sale`}
            color="primary">
            <T name="citizen_button_title_go_1stsale" />
          </Button>
        </ErrorMessage>
      );
    default:
      return <ErrorFallback className={className} {...props} />;
  }
};
